import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { BookOpen, Award } from 'lucide-react';
export const HouseOfLionsSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section id="house-of-lions" ref={sectionRef} className="py-20 md:py-28 bg-black relative overflow-hidden" style={{
    opacity
  }} data-id="element-1381">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/5 to-black z-0" data-id="element-1382"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-1383">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-1384">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-1385">
            The Chronicle Behind The Journey
          </p>
          <h2 className="font-serif text-5xl md:text-7xl text-white mb-8" data-id="element-1386">
            HOUSE OF
            <br data-id="element-1387" />
            <span className="text-amber-400" data-id="element-1388">LIONS</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-1389"></div>
        </motion.div>
        <div className="max-w-6xl mx-auto" data-id="element-1390">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start" data-id="element-1391">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="lg:col-span-2" data-id="element-1392">
              <div className="relative max-w-sm mx-auto lg:mx-0" data-id="element-1393">
                <div className="relative rounded-lg overflow-hidden border-2 border-amber-400/20" data-id="element-1394">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t3CRbn4AkSTsAZ7KzhK5CV/Book_cover.webp" alt="House of Lions Book Cover" className="w-full h-auto" data-id="element-1395" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" data-id="element-1396"></div>
                </div>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="lg:col-span-3 space-y-8" data-id="element-1397">
              <div className="border-l-2 border-amber-400/30 pl-6" data-id="element-1398">
                <p className="text-2xl text-amber-400 font-light italic mb-2" data-id="element-1399">
                  "Every great kingdom deserves its chronicle."
                </p>
              </div>
              <div className="space-y-4" data-id="element-1400">
                <p className="text-white/80 text-lg leading-relaxed font-light" data-id="element-1401">
                  <span className="text-amber-400 font-serif text-xl" data-id="element-1402">
                    House of Lions: Life in the Sikh Kingdoms
                  </span>{' '}
                  is the forthcoming historical epic that inspired this
                  immersive dining experience.
                </p>
                <p className="text-white/70 leading-relaxed font-light" data-id="element-1403">
                  Co-created with a producer credited on HBO's Game of Thrones
                  and written by A.K. Singh, this book traces the vision, valor,
                  and unity that defined Maharaja Ranjit Singh's empire — the
                  same spirit brought to life here through sound, flavor, and
                  light.
                </p>
              </div>
              <div className="border-2 border-amber-400/30 p-6 bg-black/40" data-id="element-1404">
                <div className="flex items-start gap-4" data-id="element-1405">
                  <div className="flex-shrink-0" data-id="element-1406">
                    <div className="w-12 h-12 rounded-full bg-amber-400/10 flex items-center justify-center border border-amber-400/30" data-id="element-1407">
                      <BookOpen className="w-6 h-6 text-amber-400" data-id="element-1408" />
                    </div>
                  </div>
                  <div data-id="element-1409">
                    <h4 className="text-lg font-serif text-amber-400 mb-2" data-id="element-1410">
                      Exclusive Author Meet & Greet
                    </h4>
                    <p className="text-white/70 text-sm font-light leading-relaxed" data-id="element-1411">
                      Guests at Life in the Sikh Kingdoms will have an exclusive
                      opportunity to meet the author during both evenings of the
                      event and receive a personally signed pre-release edition
                      of House of Lions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap gap-4 pt-4" data-id="element-1412">
                <div className="flex items-center gap-2 text-white/60 text-sm" data-id="element-1413">
                  <Award className="w-4 h-4 text-amber-400" data-id="element-1414" />
                  <span className="font-light" data-id="element-1415">
                    HBO Game of Thrones Producer
                  </span>
                </div>
                <div className="flex items-center gap-2 text-white/60 text-sm" data-id="element-1416">
                  <BookOpen className="w-4 h-4 text-amber-400" data-id="element-1417" />
                  <span className="font-light" data-id="element-1418">Historical Epic</span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>;
};